/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);

import React from "react";
import { createRoot } from "react-dom/client";
import { RecoilRoot } from "recoil";
import ReactRailsUJS from "react_ujs";
import RouteApp from "../components/RouteApp";
import RouteAppSchedule from "../components/RouteScheduleApp";
import InventoryReportsTable from "../components/InventoryReportsTable";
import InventoryReportsSidebar from "../components/InventoryReportsSidebar";

var componentRequireContext = require.context("components", true);
ReactRailsUJS.useContext(componentRequireContext);

document.addEventListener("DOMContentLoaded", () => {
	const reactRoot = document.getElementById("react-root");
	const reactRootSchedule = document.getElementById("react-root-schedule");
	const inventoryReportsRoot = document.getElementById("inventory-reports-table-root");

	if (reactRoot) {
		const root = createRoot(reactRoot);
		const dataAttr = reactRoot.dataset;

		root.render(
			<RecoilRoot>
				<RouteApp
					props={dataAttr}
				/>
			</RecoilRoot>
		);
		ReactRailsUJS.mountComponents(); // Ensures ReactRailsUJS
	}

	if (reactRootSchedule) {
		const root = createRoot(reactRootSchedule);
		const dataAttr = reactRootSchedule.dataset;

		root.render(
			<RecoilRoot>
				<RouteAppSchedule
					props={dataAttr}
				/>
			</RecoilRoot>
		);
		ReactRailsUJS.mountComponents(); // Ensures ReactRailsUJS
	}

	if (inventoryReportsRoot) {
		const root = createRoot(inventoryReportsRoot);
		let initialReports = [];
		const reportsData = inventoryReportsRoot.dataset.reports;

		try {
			if (reportsData) {
				const parsed = JSON.parse(reportsData);
				initialReports = Array.isArray(parsed) ? parsed : (parsed.reports || []);
			}
		} catch (error) {
			console.error('Error parsing reports data:', error);
		}

		const warehouseFilter = inventoryReportsRoot.dataset.warehouseFilter || null;
		const reportTypeFilter = inventoryReportsRoot.dataset.reportTypeFilter || null;

		root.render(
			<InventoryReportsTable
				initialReports={initialReports}
				warehouseFilter={warehouseFilter}
				reportTypeFilter={reportTypeFilter}
			/>
		);
	}

	if (document.getElementById("inventory-reports-sidebar-root")) {
		const sidebarRoot = document.getElementById("inventory-reports-sidebar-root");
		const root = createRoot(sidebarRoot);
		let warehouses = [];
		const warehousesData = sidebarRoot.dataset.warehouses;

		try {
			if (warehousesData) {
				warehouses = JSON.parse(warehousesData);
			}
		} catch (error) {
			console.error('Error parsing warehouses data:', error);
		}

		const warehouseFilter = sidebarRoot.dataset.warehouseFilter || null;
		const reportTypeFilter = sidebarRoot.dataset.reportTypeFilter || null;
		const startDate = sidebarRoot.dataset.startDate || null;
		const endDate = sidebarRoot.dataset.endDate || null;

		root.render(
			<InventoryReportsSidebar
				warehouseFilter={warehouseFilter}
				reportTypeFilter={reportTypeFilter}
				startDate={startDate}
				endDate={endDate}
				warehouses={warehouses}
			/>
		);
	}
});
